// extracted by mini-css-extract-plugin
export var root = "RichTextField-module--root--6d892";